"use client";

import type { FormEvent } from "react";
import { Button, Input, LoadingSpinner } from "@wtc/ui";
import { ChevronUp, FolderPlus } from "lucide-react";

interface CreateDriveFolderFormProps {
  hasAnyDriveAccess: boolean;
  isPending: boolean;
  newFolderName: string;
  onCancel: () => void;
  onNewFolderNameChange: (name: string) => void;
  onSubmit: (event: FormEvent) => void;
  onToggleForm: () => void;
  showCreateFolderForm: boolean;
}

export function CreateDriveFolderForm({
  hasAnyDriveAccess,
  isPending,
  newFolderName,
  onCancel,
  onNewFolderNameChange,
  onSubmit,
  onToggleForm,
  showCreateFolderForm,
}: CreateDriveFolderFormProps) {
  return (
    <>
      <div className="flex gap-2">
        <Button
          variant="outline"
          onClick={onToggleForm}
          className="flex-1"
          disabled={!hasAnyDriveAccess}
        >
          {showCreateFolderForm ? (
            <>
              <ChevronUp className="h-4 w-4 mr-2" />
              Cancel
            </>
          ) : (
            <>
              <FolderPlus className="h-4 w-4 mr-2" />
              Create New Folder
            </>
          )}
        </Button>
      </div>

      {showCreateFolderForm && (
        <form
          onSubmit={onSubmit}
          className="p-4 bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800 rounded-lg space-y-3"
        >
          <div>
            <label
              htmlFor="newFolderName"
              className="text-sm font-medium text-amber-900 dark:text-amber-200 block mb-2"
            >
              Folder Name
            </label>
            <Input
              id="newFolderName"
              type="text"
              value={newFolderName}
              onChange={(e) => onNewFolderNameChange(e.target.value)}
              placeholder="Enter folder name..."
              autoFocus
              maxLength={255}
              disabled={isPending}
              className="w-full"
            />
          </div>
          <div className="flex gap-2 justify-end">
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
              disabled={isPending}
              size="sm"
            >
              Cancel
            </Button>
            <Button type="submit" disabled={isPending || !newFolderName.trim()} size="sm">
              {isPending ? (
                <>
                  <LoadingSpinner className="h-4 w-4 mr-2" />
                  Creating...
                </>
              ) : (
                <>
                  <FolderPlus className="h-4 w-4 mr-2" />
                  Create
                </>
              )}
            </Button>
          </div>
        </form>
      )}
    </>
  );
}
